module.exports = __webpack_public_path__ + "img/rosa_sudeck_8.95e042ef.jpg";